"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmount = void 0;
function formatAmount(input) {
    return input.toLocaleString("nl-NL", { minimumFractionDigits: 2 });
}
exports.formatAmount = formatAmount;
